export const ObjectTypes = {
    BOOKING_EVENT: 'bookingevent',
    EVENT_TYPE: 'eventtype',
    CLIENT: 'client',
    BOOKABLE_RESOURCE: 'bookableresource',
    FORM_SUBMISSION: 'formsubmission',
    FORM: 'form',
    PACKAGE_GRANT: 'packagegrant',
    CLASS: 'class',
};

export const ObjectTypeHumanNames = {
    [ObjectTypes.BOOKING_EVENT]: 'Events',
    [ObjectTypes.CLIENT]: 'Clients',
    [ObjectTypes.BOOKABLE_RESOURCE]: 'Bookable People/Resources',
    [ObjectTypes.FORM_SUBMISSION]: 'Form Submissions',
    [ObjectTypes.FORM]: 'Forms',
    [ObjectTypes.EVENT_TYPE]: 'Event Type',
    [ObjectTypes.CLASS]: 'Class',
};
